import { User, getAuth } from "@atgof-firebase/firebase";

export async function authHeadersForUser(
  user: User | null,
  forceRefresh?: boolean,
): Promise<Record<string, string>> {
  const idToken = await user?.getIdToken(forceRefresh);
  return idToken ? { Authorization: "Bearer " + idToken } : {};
}

function getUser() {
  return new Promise<User | null>((resolve) => {
    const unsubscribe = getAuth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });
}

export async function authHeadersForCurrentUser() {
  return authHeadersForUser(await getUser());
}
